import React, { useEffect, useCallback, useState } from 'react';
import { fireStore } from '../../firebaseConfig';
import { collection, getDocs, query, where, deleteDoc, doc, updateDoc,onSnapshot, Firestore, setDoc } from 'firebase/firestore';
import {db} from '../../firebaseConfig';

const Account = () => {
  const [signupAccountrequest, setsignupAccountrequest] = useState([]);
  const [specialPermission,setSpecialPermission]=useState(false);
  const [isChecked,setIsChecked]= useState(false);
  

  const fetchSignupRequest = useCallback(() => {
    try {
      const collectionRef = collection(fireStore, 'SignupRequests');
      const q = query(collectionRef, where('approved', '==', true));
      
      // Use onSnapshot to listen for real-time updates
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const signuprequestList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setsignupAccountrequest(signuprequestList);
      });

      // Cleanup the listener on unmount
      return () => unsubscribe();
    } catch (error) {
      console.error('Error fetching signuprequest:', error);
    }
  }, [setsignupAccountrequest]);

  useEffect(() => {
    fetchSignupRequest();
  }, [fetchSignupRequest]);


  useEffect(() => {
    const unsubscribe = fetchSignupRequest();

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, [fetchSignupRequest]);


 

  const handleApprove = async (id) => {
    try {
      const docId = String(id); // Convert id to string
      const docRef = doc(db, 'SignupRequests', docId); // Use db from firebaseConfig
      await updateDoc(docRef, { approved: false });
      alert("User UnApproved");
      setsignupAccountrequest(prevRequests => prevRequests.filter(request => request.id !== docId));
    } catch (error) {
      console.error('Error updating signuprequest:', error);
    }
  };


  const handlePermission = async(isChecked)=>{
    const colRef = collection(fireStore,"Admins");
    const docRef = doc(colRef,"SpecialPermission");

    const Permission = {
      status: isChecked
    }

    await setDoc(docRef,Permission)
    alert(`Special Permission Changed to ${isChecked} Successfully.`)

  }
  
  
  
  

  return (
    <div className="p-8 bg-lightgray ">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <h2 className="text-2xl font-semibold mb-4 md:mb-0 font-lato">Accounts</h2>
       
      </div>
      <label className="flex items-center">
      <span className="slider font-bold text text-liquidblue">Special Permission   </span>
      <input className='w-5 h-5 ml-4'
        type="checkbox"
        checked={isChecked}
        onChange={()=>{setIsChecked(!isChecked)
          handlePermission(!isChecked);
        }}
        
      />
     
    </label>

      <div className="container mx-auto bg-white p-4 mt-2 rounded-lg shadow-lg">
        <div className="">
         
         <div className='h-[490px] overflow-y-scroll'>
          <table className="min-w-full bg-white border">
            <thead>
              <tr className="uppercase text-sm leading-normal">
                <th className="py-3 px-6 text-left font-lato font-bold text-liquidblue font-2xl">Name</th>
                <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Designation</th>
                <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Phone</th>
                <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Password</th>
                <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Action</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm font-light overflow-y-scroll">
              {signupAccountrequest.map((request) => (
                <tr key={request.id} className="border-b border-gray-200 hover:bg-gray-100 shadow-xl">
                  <td className="py-3 px-6 text-left whitespace-nowrap font-lato font-bold text-black">{request.user.name}</td>
                  <td className="py-3 px-6 text-center font-lato font-bold text-black">{request.user.role}</td>
                  <td className="py-3 px-6 text-center font-lato font-bold text-black">{request.user.phone}</td>
                  <td className="py-3 px-6 text-center font-lato font-bold text-black">{request.password}</td>
                  <td className="py-3 px-6 text-center">
                    <button
                      className="bg-darkteal text-white px-4 py-2 rounded-lg font-lato font-bold"
                      onClick={() => handleApprove(request.id)}
                    >
                      UnApprove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default Account;
